import React from "react";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import Box from "../../../../components/Box";
import { ConstantService } from "../../../../services/ConstantService";
import { CompanyService } from "../../../../services/CompanyService";
import { GetCountryListResponseData } from "../../../../models/response/country/GetCountryListResponse";

interface Props {
    firmInformationRef: any
    trCountry: GetCountryListResponseData | undefined
    senderCustomerCode: string | undefined
    setSenderCustomerCode: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedSenderCustomer: CustomSingleSelectModel | undefined
    setSelectedSenderCustomer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    senderCustomerAddress: string | undefined
    setSenderCustomerAddress: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedSenderCounty: CustomSingleSelectModel | undefined
    setSelectedSenderCounty: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedSenderDistrict: CustomSingleSelectModel | undefined
    setSelectedSenderDistrict: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    receiverCustomerCode: string | undefined
    setReceiverCustomerCode: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedReceiverCustomer: CustomSingleSelectModel | undefined
    setSelectedReceiverCustomer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    receiverCustomerAddress: string | undefined
    setReceiverCustomerAddress: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedReceiverCounty: CustomSingleSelectModel | undefined
    setSelectedReceiverCounty: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedReceiverDistrict: CustomSingleSelectModel | undefined
    setSelectedReceiverDistrict: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
}

const FirmInformation = ({
    firmInformationRef,
    senderCustomerCode,
    trCountry,
    setSenderCustomerCode,
    selectedSenderCustomer,
    setSelectedSenderCustomer,
    senderCustomerAddress,
    setSenderCustomerAddress,
    selectedSenderCounty,
    setSelectedSenderCounty,
    selectedSenderDistrict,
    setSelectedSenderDistrict,
    receiverCustomerCode,
    setReceiverCustomerCode,
    selectedReceiverCustomer,
    setSelectedReceiverCustomer,
    receiverCustomerAddress,
    setReceiverCustomerAddress,
    selectedReceiverCounty,
    setSelectedReceiverCounty,
    selectedReceiverDistrict,
    setSelectedReceiverDistrict
}: Props) => {
    return (
        <div className='containerPart' ref={firmInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Firma Bilgileri</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <CustomTextInput labelText='Gönderici Müşteri Kodu' isLabelRequired value={senderCustomerCode} setValue={setSenderCustomerCode} isDisabled />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText='Yurtiçi Gönderici'
                                isLabelRequired
                                selectedValue={selectedSenderCustomer}
                                onChange={setSelectedSenderCustomer}
                                onMenuOpen={[
                                    () => CompanyService.getCompanyList({ isCustomer: true })
                                ]}
                                labelName='name'
                                valueName='companyId'
                                disabled
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Çıkış İl"
                                isLabelRequired
                                selectedValue={selectedSenderCounty}
                                onChange={(selectedItem) => {
                                    setSelectedSenderCounty(selectedItem);
                                    setSelectedSenderDistrict(undefined);
                                }}
                                onMenuOpen={trCountry ? () => ConstantService.getConstantList('COUNTY', trCountry.countryId) : undefined}
                                labelName='value'
                                valueName='constantId'
                                disabled
                            />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-8">
                            <CustomTextInput labelText='Yurtiçi Gönderici Adres' isLabelRequired value={senderCustomerAddress} setValue={setSenderCustomerAddress} isDisabled />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Çıkış İlçe"
                                isLabelRequired
                                selectedValue={selectedSenderDistrict}
                                onChange={setSelectedSenderDistrict}
                                onMenuOpen={selectedSenderCounty ? () => ConstantService.getConstantList('DISTRICT', selectedSenderCounty.value) : undefined}
                                labelName='value'
                                valueName='constantId'
                                disabled
                            />
                        </div>
                    </div>

                    <Box className="mt-5" bg="rgb(241, 241, 244)" height="1px" width="100%">&nbsp;</Box>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <CustomTextInput labelText='Alıcı Müşteri Kodu' isLabelRequired value={receiverCustomerCode} setValue={setReceiverCustomerCode} isDisabled />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText='Yurtiçi Alıcı'
                                isLabelRequired
                                selectedValue={selectedReceiverCustomer}
                                onChange={setSelectedReceiverCustomer}
                                onMenuOpen={[
                                    () => CompanyService.getCompanyList({ isCustomer: true })
                                ]}
                                labelName='name'
                                valueName='companyId'
                                disabled
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Teslim İl"
                                isLabelRequired
                                selectedValue={selectedReceiverCounty}
                                onChange={(selectedItem) => {
                                    setSelectedReceiverCounty(selectedItem);
                                    setSelectedReceiverDistrict(undefined);
                                }}
                                onMenuOpen={trCountry ? () => ConstantService.getConstantList('COUNTY', trCountry.countryId) : undefined}
                                labelName='value'
                                valueName='constantId'
                                disabled
                            />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-8">
                            <CustomTextInput labelText='Yurtiçi Alıcı Adres' isLabelRequired value={receiverCustomerAddress} setValue={setReceiverCustomerAddress} isDisabled />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Teslim İlçe"
                                isLabelRequired
                                selectedValue={selectedReceiverDistrict}
                                onChange={setSelectedReceiverDistrict}
                                onMenuOpen={selectedReceiverCounty ? () => ConstantService.getConstantList('DISTRICT', selectedReceiverCounty.value) : undefined}
                                labelName='value'
                                valueName='constantId'
                                disabled
                            />
                        </div>
                    </div>


                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default FirmInformation;